export const getVoteGenderTranslate = (
  gender: string | null
): string | null => {
  if (gender === "Female") return "Для женщин";
  if (gender === "Male") return "Для мужчин";
  if (gender === "Any") return "Для всех";
  if (gender === "") return "Не указанно";
  return gender;
};
